// @ts-nocheck
import Vue from 'vue'

// @index(['./*.vue', './*/index.vue'], (f, _) => `import { default as Tv${_.pascal(f.path.replace('/index', ''))} } from '${f.path}${f.ext}'`)
import { default as TvEmpty } from './empty.vue'
import { default as TvGoodsItem } from './goods_item.vue'
import { default as TvIcon } from './icon.vue'
import { default as TvPage } from './page.vue'
import { default as TvStepper } from './stepper.vue'
import { default as TvWaterfall } from './waterfall.vue'
// @endindex

// @index(['./*.vue', './*/index.vue'], (f, _) => `Vue.component('Tv${_.pascal(f.path.replace('/index', ''))}', Tv${_.pascal(f.path.replace('/index', ''))})`)
Vue.component('TvEmpty', TvEmpty)
Vue.component('TvGoodsItem', TvGoodsItem)
Vue.component('TvIcon', TvIcon)
Vue.component('TvPage', TvPage)
Vue.component('TvStepper', TvStepper)
Vue.component('TvWaterfall', TvWaterfall)
// @endindex
